'use client';

import { NavItem } from './components';
import { createNavigation } from './utils';

export const NavBar = () => {
  const navigation = createNavigation();

  return (
    <div className="fixed flex flex-row items-center w-full border-t border-t-foreground/15 shadow-2xl min-h-14 bottom-0 z-10 bg-background-dark">
      {navigation.map((item) => (
        <NavItem key={item.label} {...item} />
      ))}
    </div>
  );
};
